import "scripts/templates/page.landing.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.page.landing");
